import React from 'react'
import { useSelector } from 'react-redux'
import Factor from './Factor'
import './Factors.css'
import i18n from '../../../i18n'
import CompText from '../Compliance/CompText'
import ProgressBar from '../Components/ProgressBar'
import { SomethingWentWrong } from '../Components/ErrorHandle'

const Factors = () => {
  let data = useSelector(state => state.fundData.data)
  data = data.map((x) => {
    if (x.multifactorTilts && x.multifactorTilts.length === 0) {
      x.multifactorTilts = null;
    }
    return x;
  });

  const dataFilter = data.filter(x => x.aggregateFundamentals !== null);
  const hasFactorData = dataFilter.length > 0  

  const loadingFactors= useSelector(state => state.fundData.loadingCatchAll)
  const errorCatchAll= useSelector(state => state.fundData.errorCatchAll)
  const hasBlendedData= useSelector(state => state.fundData.hasBlendedData)
  

  //if we are still fetching data and current loaded data has factors
  const ProgressBarIfGettingBlendedData = () => {
    return (
      (loadingFactors && hasFactorData && hasBlendedData) && (
        <div>
          <ProgressBar message={i18n.t('loading_blended')}/>
          <div style={{ marginBottom: '65px' }} />
        </div>
      )
    );
  };

  if (errorCatchAll) {
    return(
      <div>
        <SomethingWentWrong />
        <CompText pane='Factors' />
    </div>
    )
  }
  
  //if we are still fetching data and current loaded data has no factors
  if (loadingFactors && !hasFactorData) {
    return(
      <div>
        <ProgressBar title={'CORRELATION AND MOMENTUM'} message={i18n.t('loading_factors')} />
        <CompText pane='Factors' />
      </div>
    )
  } 


  //if we are done fetching data and current loaded data has no factors
  if (!loadingFactors && !hasFactorData) {
    return (
      <div>
        <div className='noData'>{i18n.t('no-data')} </div>
        <div style={{ marginBottom: '65px' }} />
        <CompText pane='Factors' />
      </div>
    )
  }

  return (
    <div className='fund-char-factors'>
      <ProgressBarIfGettingBlendedData />
      <div className='row'>
        <Factor name='Correlation' data={data} />
        <Factor name='Momentum' data={data} />
        <Factor name='Quality' data={data} />
        <Factor name='Value' data={data} />
      </div>
      <div className='factorCompliance'>{i18n.t('comp-factors')}</div>
      <CompText pane='Factors' />
    </div>
  )
}

export default Factors
